<template>
  <div v-if="item" class="selectableCard cursor-pointer form-group position-relative lightGreyBg px-4 py-3 rounded border border-lightGreyBg"
    :class="{ 'selected': isSelected }" @click="toggle">
    <span v-if="isSelected" class="evaluatonChecked">
      <img src="../../assets/images/evaluationcheckedIcon.svg" alt="">
    </span>
    <div class="radioCheck customRadiocheck d-flex gap-2 align-items-center">
      <div class="form__radio-group">
        <input type="radio" class="form__radio-input" :checked="true" readonly>
        <label class="form__radio-label" :class="item.value == 2 ? 'yellowRadio' : 'redRadio'">
          <span class="form__radio-button"></span>
        </label>
      </div>
      <h6 class="mb-0">{{ item.option }}</h6>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectableItem",
  props: {
    item: { type: Object, default: null },
    isSelected: { type: Boolean, default: false }
  },
  emits: ["update:selected"],
  methods: {
    toggle() {
      this.$emit("update:selected", !this.isSelected);
    }
  }
};
</script>

<style scoped>
.selected {
  border: 1.5px solid #092E87 !important;
  /* blue border */
}

.evaluatonChecked {
  position: absolute;
  top: -10px;
  right: 10px;
}
.evaluatonChecked img {
    width: 20px;
    height: 20px;
}

.selectableCard {
  margin-bottom: 20px !important;
}

@media (max-width: 576px) {

.selectableCard {
  margin-bottom: 10px !important;
}
  .evaluatonChecked {
    position: absolute;
    display: flex;
    align-items: center;
    height: 100%;
    top: 0;
    right: 0;
    padding: 0 1rem;
  }
}
</style>
